<modal-header [title]="marketingPush.organizationName"></modal-header>

<ion-content>
    <bb-marketing-push [marketingPush]="marketingPush" [hideUser]="true"></bb-marketing-push>
</ion-content>

<modal-footer [hideSubmit]="true"></modal-footer>
